import { useMemo } from "react";

import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableCellSpace from "ds/components/Table/Row/CellSpace";
import { Context } from "types/generated";
import { ContextSuggestions } from "shared/Context/constants";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import useContextsAnalytics from "../../useContextsAnalytics";
import useCellFilterAction from "../useCellFilterAction";

const ContextsTableSpaceCell = ({ item: context, ...cellProps }: TableSimpleCellProps<Context>) => {
  const trackAnalytics = useContextsAnalytics();

  const isEmpty = !context.spaceDetails;

  const spaceFilterAction = useCellFilterAction({
    filterName: ContextSuggestions.Space,
    filterValue: context.spaceDetails.id,
    spaceCell: true,
  });

  const actions = useMemo(() => (isEmpty ? [] : [spaceFilterAction]), [spaceFilterAction, isEmpty]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      {isEmpty && <TableCellEmpty />}

      {!isEmpty && (
        <TableCellSpace
          href={`/spaces/${context.spaceDetails.id}`}
          onPress={() => trackAnalytics("Space link clicked")}
        >
          {context.spaceDetails.name}
        </TableCellSpace>
      )}
    </TableSimpleCell>
  );
};

export default ContextsTableSpaceCell;
